import { render, staticRenderFns } from "./commercialTags.vue?vue&type=template&id=d941b6e0"
import script from "./commercialTags.vue?vue&type=script&lang=js"
export * from "./commercialTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports